__turbopack_context__.v({
  "downArrowContainer": "u8ZglG_downArrowContainer",
  "iconContainer": "u8ZglG_iconContainer",
  "infoCardContainer": "u8ZglG_infoCardContainer",
});
